import React from "react";
import { Carousel } from "react-bootstrap";

const Content = () => {
  return (
    <div className="content-container">
	<div className="mx-auto" style={{ width: "80%", marginBottom: "20px" }}>
      <Carousel fade interval={3000} className="shadow-sm rounded overflow-hidden">
		  <Carousel.Item>
			<img
			  className="d-block w-100"
			  src="https://alive.my.id/kehati_sementara/gbrhome/1.jpeg"
			  alt="Alamanda"
			  style={{ height: "400px", objectFit: "cover" }}
			/>
			
		  </Carousel.Item>

		  <Carousel.Item>
			<img
			  className="d-block w-100"
			  src="https://alive.my.id/kehati_sementara/gbrhome/2.jpeg"
			  alt="Alpukat"
			  style={{ height: "400px", objectFit: "cover" }}
			/>
		  </Carousel.Item>

		  <Carousel.Item>
			<img
			  className="d-block w-100"
			  src="https://alive.my.id/kehati_sementara/gbrhome/3.jpeg"
			  alt="Kecrutan"
			  style={{ height: "400px", objectFit: "cover" }}
			/>
		  </Carousel.Item>
		  
		  <Carousel.Item>
			<img
			  className="d-block w-100"
			  src="/gbrhome/4.jpeg"
			  alt="Kecrutan"
			  style={{ height: "400px", objectFit: "cover" }}
			/>
		  </Carousel.Item>
		  
		  <Carousel.Item>
			<img
			  className="d-block w-100"
			  src="https://alive.my.id/kehati_sementara/gbrhome/5.jpeg"
			  alt="Kecrutan"
			  style={{ height: "400px", objectFit: "cover" }}
			/>
		  </Carousel.Item>
		  
		  <Carousel.Item>
			<img
			  className="d-block w-100"
			  src="https://alive.my.id/kehati_sementara/gbrhome/6.jpeg"
			  alt="Kecrutan"
			  style={{ height: "400px", objectFit: "cover" }}
			/>
		  </Carousel.Item>
		  
		  <Carousel.Item>
			<img
			  className="d-block w-100"
			  src="https://alive.my.id/kehati_sementara/gbrhome/7.jpeg"
			  alt="Kecrutan"
			  style={{ height: "400px", objectFit: "cover" }}
			/>
		  </Carousel.Item>
		</Carousel>
	</div>
      <div className="content-text">
        
		<p className="text-justify">
        <strong>PT. Perusahaan Gas Negara (Persero) Tbk. (PGN)</strong> merupakan
        perusahaan yang bergerak di bidang transportasi dan distribusi gas bumi,
        yang menghubungkan pasokan gas bumi Indonesia dengan konsumen di seluruh
        penjuru Nusantara. Strategic Business Unit Transmisi Sumatera-Jawa yang
        selanjutnya disebut <strong>SBU TSJ</strong> adalah unsur pelaksana bisnis
        operasi transmisi gas bumi PT. Perusahaan Gas Negara (Persero) Tbk, yang
        berkedudukan di Jakarta serta meliputi wilayah Sumatera-Jawa. Wilayah
        operasi SBU TSJ meliputi Jalur Pipa Transmisi Gas Grissik (GRS) – Pagardewa
        (PGD) – Labuhan Maringgai (LBM) – Muara Bekasi (MBK) dan Jalur Pagardewa
        (PGD) – Labuhan Maringgai (LBM) – Bojonegara (BJN).
      </p>

      <p className="text-justify">
        Salah satu Kebijakan <strong>Keselamatan, Kesehatan Kerja dan Pengelolaan
        Lingkungan serta Energi (K3PL-E)</strong> Perusahaan adalah melakukan
        tindakan proaktif dan preventif agar tercapai lingkungan kerja yang aman,
        higienis, tidak terjadi pencemaran lingkungan dan efisiensi dalam
        pemanfaatan energi. Sejalan dengan Kebijakan K3PL-E PGN serta
        berkembangnya paradigma tentang pembangunan berkelanjutan
        (<em>sustainable development</em>) yang menuntut peran korporasi/entitas
        bisnis untuk turut mendukung terlaksananya tata perekonomian dunia yang
        lebih adil, baik untuk generasi sekarang maupun generasi mendatang, hal ini
        telah mendorong dikembangkannya satu <em>etika bisnis</em> yang lebih
        bertanggung jawab terhadap lingkungan. Mengacu kepada hal tersebut membuat
        orientasi tanggung jawab perusahaan juga berkembang mencakup tanggung jawab
        lingkungan dan sosial (<em>environment and social responsibility</em>).
        Hal ini menjadikan faktor lingkungan dan keanekaragaman hayati
        (<em>biodiversity</em>) di sekitar area operasi saat ini juga dimasukkan
        dalam proses penentuan tujuan perusahaan.
      </p>

      <p className="text-justify">
        Salah satu bentuk perwujudan tanggung jawab perusahaan terkait hal tersebut
        di atas adalah keberpihakan dan keterlibatan perusahaan dalam upaya
        perlindungan lingkungan termasuk di dalamnya perlindungan dan pelestarian
        keanekaragaman hayati baik <em>in situ</em> maupun <em>ex situ</em>.
      </p>

      <p className="text-justify">
        <strong>Keanekaragaman hayati</strong> atau <em>biodiversitas
        (biodiversity)</em> merupakan istilah yang mencakup semua bentuk kehidupan,
        yang secara ilmiah dapat dikelompokkan menurut skala organisasi biologisnya,
        yaitu mencakup gen, spesies tumbuhan, hewan dan mikroorganisme serta
        ekosistem dan proses-proses ekologi, di mana bentuk kehidupan ini merupakan
        bagiannya. Dapat juga diartikan sebagai kondisi keanekaragaman bentuk
        kehidupan dalam ekosistem atau bioma tertentu. Keanekaragaman hayati
        seringkali digunakan sebagai ukuran kesehatan sistem biologis.
      </p>

      <p className="text-justify">
        Disamping untuk mengimplementasikan Kebijakan K3PL-E seperti disebutkan di
        atas, PGN SBU TSJ mengikuti program <strong>PROPER</strong> yang telah
        mendapatkan peringkat <strong>Biru</strong> pada tahun 2013. PGN SBU TSJ
        bermaksud untuk melakukan pengelolaan lingkungan <em>beyond compliance</em>,
        oleh sebab itu perlu mempersiapkan diri menuju <strong>PROPER Hijau</strong>.
        Di dalam PROPER Hijau terdapat sembilan kriteria penilaian di mana salah
        satunya adalah kriteria <strong>Perlindungan Keanekaragaman Hayati</strong>.
        Oleh karenanya kegiatan ini menjadi salah satu upaya untuk mempersiapkan
        menuju PROPER Hijau tersebut.
      </p>

      <p className="text-justify">
        Perlindungan Keanekaragaman Hayati pada dasarnya bukan jumlah pohon yang
        dinilai, tetapi lebih diutamakan pada upaya pemeliharaan dan perawatan
        keanekaragaman hayati. Salah satu bukti bahwa perusahaan peduli dengan
        keanekaragaman hayati adalah memiliki sistem informasi yang dapat
        mengumpulkan dan mengevaluasi status dan kecenderungan sumber daya
        keanekaragaman hayati dan sumber daya biologis yang dikelola.
      </p>

      <p className="text-justify">
        Sebagai langkah konkret perusahaan dalam perlindungan keanekaragaman hayati,
        perlu dirumuskan dan dilakukan secara sistematis serta dituangkan dalam
        bentuk dokumen <strong>Rencana Strategis Pengelolaan Keanekaragaman
        Hayati</strong>, dengan batasan wilayah dan penzonasian yang jelas sehingga
        secara sistematis dapat dipantau perkembangannya.
      </p>

      <p className="text-justify">
        Untuk menyusun Rencana Strategis Pengelolaan Keanekaragaman Hayati, maka
        kondisi keanekaragaman hayatinya harus diketahui terlebih dahulu. Langkah
        awal yang dilakukan adalah memetakan kondisi dan menyusun profil
        keanekaragaman hayati kemudian menyusun rencana pengelolaannya.
      </p>
		
      </div>
    </div>
  );
};

export default Content;